import { Platform } from '@angular/cdk/platform';
import { NgClass } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input, inject } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { TranslocoDirective, provideTranslocoScope } from '@jsverse/transloco';
import { WA_NAVIGATOR } from '@ng-web-apis/common';
import { RmaIconComponent, RmaIcons } from '@rma/generic/ui/icon';
import { ShareButtonDirective } from '../share-button.directive';

@Component({
  selector: 'rma-share-button',
  templateUrl: './share-button.component.html',
  providers: [provideTranslocoScope('shareButton')],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [MatButtonModule, ShareButtonDirective, RmaIconComponent, TranslocoDirective, NgClass],
})
export class ShareButtonComponent {
  private readonly navigator = inject<Navigator>(WA_NAVIGATOR);
  private readonly platform = inject(Platform);

  @Input({ required: true })
  data: ShareData | null = null;

  @Input()
  buttonType: 'icon' | 'text' | 'both' | 'responsive' = 'both';

  icon: RmaIcons = 'share';

  constructor() {
    if (this.navigator) {
      const lowerCaseUA = this.navigator.userAgent.toLowerCase();
      const isAppleDevice = this.platform.IOS || this.platform.SAFARI || lowerCaseUA.includes('macintosh');
      this.icon = isAppleDevice ? 'ios_share' : 'share';
    }
  }
}
